import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { LockedTimeSlotType } from '../pages/appointment-calendar/interface/time-slot'
import { AuthService } from 'src/app/services/auth.service'
import { ServerUrlService } from 'src/app/services/server-url.service'
import { WebsocketService } from 'src/app/services/websocket.service'
import { ResBodyType } from 'otimus-shared'
import { LockedTimeSlotReqType } from '../pages/appointment-calendar/interface/locked-time-slot'

@Injectable({
  providedIn: 'root',
})
export class LockedTimeSlotService {
  constructor(
    private httpService: HttpClient,
    private authService: AuthService,
    private serverUrl: ServerUrlService,
    private websocket: WebsocketService
  ) {}

  getLockedTimeSlots(scheduleIds: number[]): Observable<ResBodyType<LockedTimeSlotType[]>> {
    let params = new HttpParams()
    for (const scheduleId of scheduleIds.length > 0 ? scheduleIds : [-1]) {
      params = params.append('scheduleId', scheduleId)
    }
    return this.httpService.get<ResBodyType<LockedTimeSlotType[]>>(`${this.serverUrl.url}/time-slot/locked`, {
      params,
      headers: {
        Authorization: `Bearer ${this.authService.token}`,
      },
    })
  }

  lockTimeSlot(body: LockedTimeSlotReqType): Observable<ResBodyType> {
    return this.httpService.post<ResBodyType>(`${this.serverUrl.url}/time-slot/locked`, body, {
      headers: {
        Authorization: `Bearer ${this.authService.token}`,
      },
    })
  }

  createForceEntryAudit(scheduleId: number, date: string, time: string): Observable<ResBodyType> {
    return this.httpService.post<ResBodyType>(
      `${this.serverUrl.url}/time-slot/locked/force-entry-audit`,
      { scheduleId, date, time },
      {
        headers: {
          Authorization: `Bearer ${this.authService.token}`,
        },
      }
    )
  }

  deleteLockedTimeSlot(scheduleId: number, date: string, time: string): Observable<ResBodyType> {
    return this.httpService.delete<ResBodyType>(
      `${this.serverUrl.url}/time-slot/locked?scheduleId=${scheduleId}&date=${date}&time=${time}`,
      {
        headers: {
          Authorization: `Bearer ${this.authService.token}`,
        },
      }
    )
  }

  listen<T>(eventName: string): Observable<T> {
    return this.websocket.listen<T>(eventName)
  }

  emit<T>(eventName: string, data: T): void {
    this.websocket.emit(eventName, data)
  }
}
